export const openSocialShareWindow = (href: string) => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const popupWidth = 600;
  const popupHeight = 500;

  const options = `
    width=${popupWidth},
    height=${popupHeight},
    menubar=no,
    toolbar=no,
    resizable=yes,
    scrollbars=yes,
    left=${(windowWidth - popupWidth) / 2},
    top=${(windowHeight - popupHeight) / 2}
  `;

  window.open(href, '', options);
};
